import { getNumber } from '../_metronic/helpers'
import { setupAxios } from '../app/modules/auth'
import {
  GeneralSettingInput,
  LeavePolicyInput,
  LeaveSettingInput,
  LeaveTypeInput,
} from '../app/types/SettingModuleTypes'
import { API_BASE_URL } from '../utils/contants'
import { api } from './APIMiddlewares'
import API from './APIUrl'

// Get system configuration including financial year
export async function getSystemConfiguration() {
  const { token, tenantId } = setupAxios()
  return await api.get(
    `/${API.CONFIGURATION}`,
    token,
    tenantId,
    false
  )
}

// form save api integration
export async function addConfiguration(InputField: {
  salaryComponentName: string
  salaryComponentValue: string
  salaryComponentUnit: string
}) {
  const { token, tenantId } = setupAxios()

  const res = await fetch(API_BASE_URL + `/configuration`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
    body: JSON.stringify({
      salaryComponentName: InputField.salaryComponentName,
      salaryComponentValue: InputField.salaryComponentValue,
      salaryComponentUnit: InputField.salaryComponentUnit,
    }),
  })
  return await res.json()
}

//edit by id
export async function updateConfigurationById(
  InputField: {
    salaryComponentName: string
    salaryComponentValue: string
    salaryComponentUnit: string
  },
  id: string
) {
  const { token, tenantId } = setupAxios()
  const res = await fetch(API_BASE_URL + `/configuration/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
    body: JSON.stringify({
      salaryComponentName: InputField.salaryComponentName,
      salaryComponentValue: InputField.salaryComponentValue,
      salaryComponentUnit: InputField.salaryComponentUnit,
    }),
  })
  return await res.json()
}

//   get Configuration

export async function getConfigurations() {
  const { token, tenantId } = setupAxios()
  const res = await fetch(API_BASE_URL + `/configuration`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  const data = await res.json()
  return data
}

//   delete configuration

export async function deleteConfigurations(id: string) {
  const { token, tenantId } = setupAxios()
  const res = await fetch(API_BASE_URL + `/configuration/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return await res.json()
}

//getConfigurationbyid

export async function getConfigurationsById(userId: string | undefined) {
  const { token, tenantId } = setupAxios()
  const res = await fetch(API_BASE_URL + `/configuration/${userId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  const data = await res.json()
  return data
}

export async function getGeneralConfig() {
  const { token, tenantId } = setupAxios()
  return await api.get(`/${API.CONFIGURATION}`, token, tenantId, false)
}
export async function updateGeneralConfiguration(InputField: GeneralSettingInput, id: string) {
  const { token, tenantId } = setupAxios()

  return await api
    .put(
      `/${API.CONFIGURATION}`,
      token,
      tenantId,
      {
        body: JSON.stringify({
          weekendDays: InputField?.weekends ?? [],
          weekStartDay: InputField?.week_start_day ?? '',
          financialYearStartDate: InputField?.fiscal_year_start_date,
          financialYearEndDate: InputField?.fiscal_year_end_date,
          inTime: InputField?.inTime,
          outTime: InputField?.outTime,
        }),
      },
      true
    )
    .then((res) => res)
}

// Leave Config removed – all settings via Leave Policy

export async function getLeavePolicies() {
  const { token, tenantId } = setupAxios()
  return await api.get(`/${API.LEAVEPOLICY}/all`, token, tenantId, false).then((res) => res)
}

export async function getLeavePoliciesById(id: String) {
  const { token, tenantId } = setupAxios()
  return await api.get(`/${API.LEAVEPOLICY}/${id}`, token, tenantId, false).then((res) => res)
}

export async function deleteLeavePolicies(id: string) {
  const { token, tenantId } = setupAxios()
  return await api.delete(`/${API.LEAVEPOLICY}/${id}`, token, tenantId, true).then((res) => res)
}

export async function addLeavePolicies(formField: LeavePolicyInput) {
  const { token, tenantId } = setupAxios()
  const isProRated = formField?.isProRated === 'true'
  const payload: any = {
    leaveTypeId: formField?.leaveTypeId,
    totalPerYear: formField?.totalPerYear ? getNumber(formField?.totalPerYear) : null,
    maxDaysPerRequest: formField?.maxDaysPerRequest ? getNumber(formField?.maxDaysPerRequest) : null,
    minAdvanceNotice: formField?.minAdvanceNotice ? getNumber(formField?.minAdvanceNotice) : null,
    allowBackdated: formField?.allowBackdated === 'true' ? true : false,
    allowEmergency: formField?.allowEmergency === 'true' ? true : false,
    autoApprove: formField?.autoApprove === 'true' ? true : false,
    requiresApproval: formField?.requiresApproval === 'true' ? true : false,
    isPaid: formField?.isPaid === 'true' ? true : false,
    isProRated: isProRated,
    proRataType: isProRated ? formField?.proRataType : null,
    proRataApplicableLeaves: isProRated ? formField?.proRataApplicableLeaves : null,
    proRataCalculationRules: isProRated ? formField?.proRataCalculationRules : null,
    allowCarry: formField?.allowCarry === 'true' ? true : false,
    carryLimit: formField?.allowCarry === 'false' ? 0 : (formField?.carryLimit ? getNumber(formField?.carryLimit) : null),
  }
  Object.keys(payload).forEach((k) => {
    if (payload[k] === '' || payload[k] === null || Number.isNaN(payload[k])) delete payload[k]
  })
  return await api
    .post(
      `/${API.LEAVEPOLICY}`,
      token,
      tenantId,
      {
        body: JSON.stringify(payload),
      },
      true
    )
    .then((res) => res)
}
export async function updateLeavePoliciesById(formField: LeavePolicyInput, id: string) {
  const { token, tenantId } = setupAxios()
  const isProRated = formField?.isProRated === 'true'
  const payload: any = {
    leaveTypeId: formField?.leaveTypeId,
    totalPerYear: formField?.totalPerYear ? getNumber(formField?.totalPerYear) : null,
    maxDaysPerRequest: formField?.maxDaysPerRequest ? getNumber(formField?.maxDaysPerRequest) : null,
    minAdvanceNotice: formField?.minAdvanceNotice ? getNumber(formField?.minAdvanceNotice) : null,
    allowBackdated: formField?.allowBackdated === 'true' ? true : false,
    allowEmergency: formField?.allowEmergency === 'true' ? true : false,
    autoApprove: formField?.autoApprove === 'true' ? true : false,
    requiresApproval: formField?.requiresApproval === 'true' ? true : false,
    isPaid: formField?.isPaid === 'true' ? true : false,
    isProRated: isProRated,
    proRataType: isProRated ? formField?.proRataType : null,
    proRataApplicableLeaves: isProRated ? formField?.proRataApplicableLeaves : null,
    proRataCalculationRules: isProRated ? formField?.proRataCalculationRules : null,
    allowCarry: formField?.allowCarry === 'true' ? true : false,
    carryLimit: formField?.allowCarry === 'false' ? 0 : (formField?.carryLimit ? getNumber(formField?.carryLimit) : null),
  }
  Object.keys(payload).forEach((k) => {
    if (payload[k] === '' || payload[k] === null || Number.isNaN(payload[k])) delete payload[k]
  })
  return await api
    .put(
      `/${API.LEAVEPOLICY}/${id}`,
      token,
      tenantId,
      {
        body: JSON.stringify(payload),
      },
      true
    )
    .then((res) => res)
}

export async function addLeaveTypes(InputField: LeaveTypeInput) {
  const { token, tenantId } = setupAxios()

  return await api
    .post(
      `/${API.LEAVETYPE}`,
      token,
      tenantId,
      {
        body: JSON.stringify({
          name: InputField?.name,
          description: InputField?.description,
        }),
      },
      true
    )
    .then((res) => res)
}

//edit by id
export async function updateLeaveTypesById(InputField: LeaveTypeInput, id: string) {
  const { token, tenantId } = setupAxios()
  return await api
    .put(
      `/${API.LEAVETYPE}/${id}`,
      token,
      tenantId,
      {
        body: JSON.stringify({
          name: InputField?.name,
          description: InputField?.description,
        }),
      },
      true
    )
    .then((res) => res)
}

//   get Holiday

export async function getLeaveTypes() {
  const { token, tenantId } = setupAxios()
  return await api.get(`/${API.LEAVETYPE}`, token, tenantId, false)
}

//   delete holiday

export async function deleteLeaveTypes(id: string) {
  const { token, tenantId } = setupAxios()
  return await api.delete(`/${API.LEAVETYPE}/${id}`, token, tenantId, false)
}

//getHolidaybyid

export async function getLeaveTypesById(id: string) {
  const { token, tenantId } = setupAxios()
  return await api.get(`/${API.LEAVETYPE}/${id}`, token, tenantId, false)
}

export async function syncLeavePolicyToUser() {
  const { token, tenantId } = setupAxios()
  return await api
    .post(`/${API.LEAVEBALANCE}/sync`, token, tenantId, { body: JSON.stringify({}) }, true)
    .then((res) => res)
}
